// components/dnd/subtasks/add-subtask/add-subtask.component.jsx
import React, { useRef, useState, useEffect, useCallback } from "react";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";

import { createNewTaskk } from "../../../../firebase/firebase.utils";
import "./add-subtask.styles.scss";

const AddSubtask = ({ task, setSubtasksOpen, inputText }) => {
  const currentUser = useSelector((state) => state.user.currentUser);
  const [newSubtask, setNewSubtask] = useState("");
  const inputRef = useRef();

  // autofocus whenever task changes or mounts
  useEffect(() => {
    inputRef.current?.focus();
  }, [task]);

  const handleCreate = useCallback(async () => {
    const trimmed = newSubtask.trim();
    const parentId = task?.id;
    if (!trimmed || !parentId || !currentUser?.uid) return;

    try {
      await createNewTaskk(
        task.fromSpaceId,
        task.fromStationId,
        task.phase,
        trimmed,
        currentUser.uid,
        parentId,
        task.priority,
      );
      setNewSubtask("");
      setSubtasksOpen(true);
      inputRef.current?.focus();
    } catch (err) {
      console.error("Error creating subtask:", err);
    }
  }, [newSubtask, task, currentUser, setSubtasksOpen]);

  return (
    <motion.div
      className="addSubtask"
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
    >
      <div className="subtasks__addTrue">
        <div className="subtasks__addTrue-box" />
        <div className="subtasks__input">
          <input
            type="text"
            ref={inputRef}
            value={newSubtask}
            onChange={(e) => setNewSubtask(e.target.value)}
            placeholder={inputText}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault(); // ✋ stop the “? in URL” navigation
                handleCreate(); // 🆕 manually fire your logic
              }
            }}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default AddSubtask;
